const OAUTH_CALLBACK_PARAM = 'code';

type SearchLike =
  | string
  | URLSearchParams
  | Record<string, string | string[] | undefined>;

/**
 * True when the URL looks like an OAuth provider redirected back with an authorization `code`.
 * Used to skip the boot splash / login-form skeleton while an in-progress sign-in completes, so the
 * user isn't re-shown the full loading state mid-authentication. Accepts a query string (client),
 * a URLSearchParams, or Next's resolved searchParams object (server).
 */
export default function isOAuthCallback(search: SearchLike): boolean {
  if (typeof search === 'string') {
    return new URLSearchParams(search).has(OAUTH_CALLBACK_PARAM);
  }
  if (search instanceof URLSearchParams) {
    return search.has(OAUTH_CALLBACK_PARAM);
  }
  return search[OAUTH_CALLBACK_PARAM] !== undefined;
}
